import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/@auth/auth.service';
import { USER_PERMISSION_POLICY } from 'src/app/app.models';
import { CluLockscreenService, LOCKSCREEN_MODE } from '../clu-lockscreen/clu-lockscreen.service';

@Injectable()
export class CluPermissionService {
    constructor(
        private cluLockscreenService: CluLockscreenService,
        private authService: AuthService
    ) {}

    async handlePermission(permissions: string[]) {
        if (this.hasVisaPermission(permissions)) {
          const visa = await this.cluLockscreenService.showLockscreen({ LockscreenMode: LOCKSCREEN_MODE.ASK_FOR_PERMISSION });
          if (!visa) { throw "Action non autorisée"; }
        } else if (!this.hasPermission(permissions)) {
          throw "Action non autorisée";
        }
      }

    hasVisaPermission(permissions: string[]): boolean {
        let hasVisaPermission = false;
        const authSession = this.authService.authenticatedSession$.value!;
        if (!!authSession && !!authSession.USER_PERMS) {
            hasVisaPermission = permissions.map(permission => {
                const matchedPermission = authSession.USER_PERMS.find(p => p.CODE_PERMISSION == permission);
                return !!matchedPermission ? matchedPermission.PERMISSION_POLICY : USER_PERMISSION_POLICY.UNAUTHORIZED;
            }).reduce((sum, next) => (sum == USER_PERMISSION_POLICY.ALLOW_BY_CONTROL) || (next == USER_PERMISSION_POLICY.ALLOW_BY_CONTROL), false);
        }

        return hasVisaPermission;
    }

    hasPermission(permissions: string[]): boolean {
        let hasPermission = false;
        const authSession = this.authService.authenticatedSession$.value!;
        if (!!authSession && !!authSession.USER_PERMS) {
            hasPermission = permissions.map(permission => {
                const matchedPermission = authSession.USER_PERMS.find(p => p.CODE_PERMISSION == permission);
                return !!matchedPermission ? matchedPermission.PERMISSION_POLICY : USER_PERMISSION_POLICY.UNAUTHORIZED;
            }).reduce((sum, next) => (sum == USER_PERMISSION_POLICY.ALLOW || sum == USER_PERMISSION_POLICY.ALLOW_BY_CONTROL) && (next == USER_PERMISSION_POLICY.ALLOW || next == USER_PERMISSION_POLICY.ALLOW_BY_CONTROL), true);
        }

        return hasPermission;
    }
}